import { fromJS } from "immutable";
import * as actionTypes from "./actionTypes";
const initialState = fromJS({
  singleExchanges: {
    isLoading: true,
    data: null,
    error: "",
    cancel: 0
  },
  recurringExchanges: {
    isLoading: true,
    data: [],
    error: "",
    cancel: 0
  },
  currentTab: {
    data: "single"
  },
  tab:1
});

const exchangeActivity = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchEaSingleDataType:
      return state
        .setIn(["singleExchanges", "data"], action.payload)
        .setIn(["singleExchanges", "isLoading"], false);
    case actionTypes.fetchReDataType:
      return state
        .setIn(["recurringExchanges", "data"], action.payload)
        .setIn(["recurringExchanges", "isLoading"], false);
    case actionTypes.setExchangeType:
      return state.setIn(["currentTab", "data"], action.payload);
    case actionTypes.cancelExchangeDataType:
      return state
      .setIn(["singleExchanges", "cancel"], action.payload)
      .setIn(["singleExchanges", "isLoading"], true);
    case actionTypes.cancelReExchangeDataType:
      return state.setIn(["recurringExchanges", "cancel"], action.payload)
      .setIn(["recurringExchanges", "isLoading"], true)
      case  actionTypes.isLoadingType:
      return state.setIn(["recurringExchanges", "isLoading"], true)
      .setIn(["singleExchanges", "isLoading"], true);
      case actionTypes.setTabType:
      return state.setIn(["tab"], action.payload);
    default:
      return state;
  }
};

export default exchangeActivity;
